// https://fluidtypography.com/#usarusFluidTypographyGetStarted
{
    /* Change fontsize accordingly to the text length */
}

export const fluidXXXS = {
    fontSize: 'clamp(0.425rem, 0.955vw + 0.126rem, 1.05rem)',
    lineHeight: 'clamp(0.55rem, 0.8vw + 0.25rem, 1.15rem)',
}

export const fluidXXS = {
    fontSize: 'clamp(0.525rem, 1.055vw + 0.226rem, 1.15rem)',
    lineHeight: 'clamp(0.65rem, 0.9vw + 0.35rem, 1.25rem)',
}

export const fluidXS = {
    fontSize: 'clamp(0.625rem, 1.155vw + 0.326rem, 1.25rem)',
    lineHeight: 'clamp(0.75rem, 0.95vw + 0.45rem, 1.35rem)',
}

export const fluidSM = {
    fontSize: 'clamp(0.725rem, 1.255vw + 0.426rem, 1.35rem)',
    lineHeight: 'clamp(0.85rem, 1vw + 0.55rem, 1.45rem)',
}

export const fluidSMM = {
    fontSize: 'clamp(0.825rem, 1.355vw + 0.526rem, 1.45rem)', 
    lineHeight: 'clamp(0.95rem, 1.05vw + 0.65rem, 1.55rem)',
}

export const fluidM = {
    fontSize: 'clamp(0.938rem, 0.577vw + 0.788rem, 1.25rem)',
    lineHeight: 'clamp(1.1rem, 0.35vw + 1.05rem, 1.35rem)',
}
